import { useTranslation } from 'react-i18next';
import type { LegalDocumentContent } from '../locales/types';

export type LegalDocumentKey = 'imprint' | 'privacy' | 'terms' | 'cookie';

export function useLegalDocument(key: LegalDocumentKey): LegalDocumentContent {
    const { t } = useTranslation();
    return t(`legal.${key}`, { returnObjects: true }) as unknown as LegalDocumentContent;
}
